import { Card, CardBody, Row, Col, Badge } from 'reactstrap'
import { Award, Info } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import BreadCrumbs from 'components/breadcrumbs'
import { URL_EVENT, URL_EVENT_CERTIFICATE } from 'utils/pathUrl'

const dummyCertificates = [
  {
    id: 'PMKR-2024-TRAIN-001',
    title: 'Certificate of Training Completion',
    owner: 'Pak Mangku',
    issueDate: '2024-10-15',
    expiryDate: '2025-10-14',
    status: 'expiring',
  },
  {
    id: 'PMKR-2024-VACC-001',
    title: 'Certificate of Vaccination',
    owner: 'Chicken Batch 2024-A',
    issueDate: '2024-10-13',
    expiryDate: '2025-04-13',
    status: 'expiring',
  },
]

const EventCertificateList = () => {
  const navigate = useNavigate()

  const handleViewDetail = (id) => {
    navigate(`${URL_EVENT_CERTIFICATE}/${id}`)
  }

  return (
    <div className="px-3 pb-3 w-100">
      <div className="d-flex align-items-start gap-2 pt-3 mb-3">
        <BreadCrumbs
          breadCrumbActive="Sertifikat Event Digital"
          breadCrumbParent={'Event'}
          breadCrumbParentLink={URL_EVENT}
        />
      </div>

      <div className="mb-2">
        <h6 className="fw-bold text-secondary">
          {dummyCertificates.length} Sertifikat Aktif
        </h6>
      </div>

      <Row>
        {dummyCertificates.map((cert) => (
          <Col md="6" lg="4" key={cert.id} className="mb-3">
            <Card
              onClick={() => handleViewDetail(cert.id)}
              className="shadow-sm border-warning-subtle hover-shadow pointer"
              data-testid={`event-card-${cert.id}`}
            >
              <CardBody className="text-center">
                <div className="bg-warning-subtle rounded-circle d-inline-flex p-3 mb-2">
                  <Award size={28} className="text-warning" />
                </div>
                <h6 className="fw-bold">{cert.title}</h6>
                <div className="text-muted small mb-2">{cert.owner}</div>
                <div className="text-muted small">{cert.id}</div>

                <div className="mt-2 small">
                  <div>
                    <span className="me-1 fw-semibold">Diterbitkan:</span>
                    {new Date(cert.issueDate).toLocaleDateString('id-ID')}
                  </div>
                  <div>
                    <span className="me-1 fw-semibold">Berlaku hingga:</span>
                    {new Date(cert.expiryDate).toLocaleDateString('id-ID')}
                  </div>
                </div>

                <div className="mt-3">
                  <Badge color="light-warning" className="text-warning">
                    Expiring Soon
                  </Badge>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="mt-4 p-3 bg-warning-50 rounded-3 shadow-sm">
        <div className="d-flex align-items-center gap-2 mb-2">
          <Info size={16} className="text-warning" />
          <strong>Tentang Sertifikat Digital</strong>
        </div>
        <p className="text-muted small mb-0">
          Sertifikat digital diterbitkan untuk kegiatan seperti pelatihan,
          vaksinasi, atau inspeksi yang telah diverifikasi. Setiap sertifikat
          memiliki ID unik dan dapat diunduh sebagai PDF untuk keperluan resmi.
        </p>
      </div>
    </div>
  )
}

export default EventCertificateList
